import React, { useState, useEffect } from 'react';
import { Snackbar } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { CheckCircle, XCircle } from 'phosphor-react';

import EventEmitter from '../../../lib/eventEmitter';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    close: {
      padding: theme.spacing(0.5),
      color: '#292929',
    },
    commonBackground: {
      backgroundColor: '#FFE796',
      borderRadius: 16,
    },
    errorBackground: {
      backgroundColor: '#FBD0D0',
      borderRadius: 16,
    },
    successBackground: {
      backgroundColor: '#D2DFCB',
      borderRadius: 16,
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      color: '#2D2332',
    },
  }),
);

interface State {
  message: undefined | string;
  showNotification: boolean;
  variant: undefined | string;
}

export function ShowingsNotification(props: any) {
  const classes = useStyles(props);
  const [state, setState] = useState<State>({
    message: undefined,
    showNotification: false,
    variant: undefined,
  });
  const _handleResponse = (response: any) => {
    setState({
      message: response.responseMessage,
      showNotification: true,
      variant: response.responseStatus,
    });
  };

  useEffect(() => {
    EventEmitter.on('showingNotification', _handleResponse);
    return () => {
      EventEmitter.removeListener('showingNotification', _handleResponse);
    };
  });

  const hideNotification = () => {
    setState((prevState: any) => {
      return { ...prevState, showNotification: false };
    });
  };

  const handleClose = () => {
    hideNotification();
  };

  const background =
    state.variant === 'success'
      ? classes.successBackground
      : state.variant === 'error'
      ? classes.errorBackground
      : classes.commonBackground;
  return (
    <Snackbar
      color="green"
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
      ContentProps={{
        classes: { root: background },
      }}
      open={state.showNotification}
      autoHideDuration={3000}
      onClose={handleClose}
      message={
        <span className={classes.content}>
          {state.variant === 'error' ? (
            <XCircle
              size={24}
              color="#9B0000"
              weight="fill"
              style={{ marginRight: 5 }}
            />
          ) : (
            <CheckCircle
              size={24}
              color="#195A50"
              weight="fill"
              style={{ marginRight: 5 }}
            />
          )}
          {state.message}
        </span>
      }
    />
  );
}

export default ShowingsNotification;
